import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-free-coin-icon',
    standalone: true,
    template: `
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 21 20" [attr.width]="size" [attr.height]="size" [style.vertical-align]="'middle'">
            <g clip-path="url(#coin_free)">
                <path fill="#003cff" d="M.5 9.988C.51 4.468 4.99-.005 10.506 0c5.528.005 10.003 4.492 9.994 10.022-.009 5.513-4.5 9.987-10.017 9.978C4.968 19.991.491 15.5.5 9.988"/>
                <path fill="#121599" d="M10.5 17.719c-4.277-.056-7.712-3.406-7.707-7.731.006-4.285 3.415-7.713 7.753-7.695a7.657 7.657 0 0 1 7.662 7.763c-.028 4.241-3.401 7.612-7.709 7.663"/>
                <path fill="#003cff" d="M4.834 8.203c.417-.063.79-.122 1.162-.176.754-.11 1.505-.249 2.263-.315.417-.037.59-.25.75-.59.436-.932.902-1.85 1.357-2.773q.053-.105.111-.212c.103.032.112.123.145.189.51 1.027 1.02 2.053 1.517 3.085a.43.43 0 0 0 .362.261l3.426.488c.069.01.135.036.221.06-.2.233-.424.407-.627.604-.478.462-.942.939-1.416 1.406q-.32.313-.655.612c-.093.084-.112.18-.092.296l.65 3.702c-.171-.025-.285-.132-.416-.2l-1.94-1.015c-.323-.17-.65-.334-.968-.51a.34.34 0 0 0-.363-.002c-1.03.55-2.063 1.093-3.096 1.637-.068.036-.138.067-.233.113.19-1.102.375-2.165.56-3.229l.093-.514a.28.28 0 0 0-.092-.275c-.777-.72-1.516-1.479-2.273-2.22-.134-.13-.287-.242-.446-.422"/>
            </g>
            <defs><clipPath id="coin_free"><path fill="#fff" d="M.5 0h20v20H.5z"/></clipPath></defs>
        </svg>
    `,
})
export class FreeCoinIcon {
    @Input() size: number = 16;
}
